// extracted by mini-css-extract-plugin
export default {"pause":"Pause_pause__wJTZQ"};